/* BB1 G Truslove - reusable functions */

define('Tools', [
    'jQuery', 'Utils', 'underscore', 'SC.Configuration', 'Tools',"Profile.Model"
],
    function (
        jQuery, Utils, _, Configuration, Tools,ProfileModel
    ) {

        'use strict';

        function showErrorInModal(application, title, message) {

            var view = new Backbone.View({
                application: application
            });

            view.title = title;
            view.render = function () {
                this.$el.append('<p class="error-message">' + message + '</p><br /><div class="text-center"><button class="button-primary button-large" data-dismiss="modal">' + Utils.translate('OK') + '</button></div>');
            };
            view.showInModal();
        }

        function showSuccessInModal(application, title, message) {

            var view = new Backbone.View({
                application: application
            });

            view.title = title;
            view.render = function () {
                this.$el.append('<p class="success-message">' + message + '</p><br /><div class="text-center"><button class="button-primary button-large" data-dismiss="modal">' + Utils.translate('OK') + '</button></div>');
            };
            view.showInModal();
        }

        function trim(text) { //trim leading and ending spaces
            return text.replace(/^\s+|\s+$/g, '')
        }


        function endsWith(text, value) { //does the text end with value?
            if (!text || !value) {
                return false;
            }
            if (text.length >= value.length) {
                return text.substring(text.length - value.length) == value;
            }
            return false;
        }

        function isLive() {
            var host = SC.ENVIRONMENT.currentHostString;
            if (!host || host.indexOf("code25.com") > -1) {
                return false;
            }
            return true;
        }

        function getProfileValue(name) {

            var profile = ProfileModel.getInstance();
            var customFields = profile.get("customfields") || [];
            for (var i = 0; i < customFields.length; i++) {
                if (customFields[i].name == name && customFields[i].value) {
                    return customFields[i].value.toString();
                }
            }

        }
        function getProfileHtml(name) {

            var profile = ProfileModel.getInstance();
            var customFields = profile.get("customfields") || [];
            for (var i = 0; i < customFields.length; i++) {
                if (customFields[i].name == name && customFields[i].html) {
                    return customFields[i].html.toString();
                }
            }

        }

        
        // Make Tools module available globally
        var Tools = Tools = {
            showErrorInModal: showErrorInModal,
            endsWith: endsWith,
            trim: trim,
            showSuccessInModal: showSuccessInModal,
            isLive: isLive,
            getProfileValue:getProfileValue,
            getProfileHtml:getProfileHtml
        }
        return Tools;
    });
